import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CartService } from 'src/app/services/dhukan/cart.service';

import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';

@Component({
  selector: 'app-qrproductdetails',
  templateUrl: './qrproductdetails.component.html',
  styleUrls: ['./qrproductdetails.component.css']
})
export class QrproductdetailsComponent implements OnInit {

  cartBO: any = {};
  cartColl: any = [];
  cartView: any = {};

  @Input() productid: number = 0

  @Input() productBO: any = {}

  @Input() variationColl: any = []

  @Input() selectvariationid: any = null

  @Output() emitData = new EventEmitter();

  @Output() cartchangeData = new EventEmitter();

  constructor(private appService: DhukanDataService, public router: Router, private cartservice: CartService,
    private productFindService: NgbModal, private activeModal: NgbActiveModal) {
    this.fnServiceChanges()
  }
  fnServiceChanges() {
    this.cartView = this.cartservice.cartView;
    this.cartservice.servicecartChange.subscribe((value) => {
      this.cartView = value
      if (this.cartView.cartmain) {
        this.cartBO = this.cartView.cartmain
      }
      if (this.cartView.cartdetails) {
        this.cartColl = this.cartView.cartdetails
      }
      this.fnUpdateCartChange()
    });

  }


  ngOnInit() {

    this.cartView = this.cartservice.cartView;
    if (this.cartView.cartmain) {
      this.cartBO = this.cartView.cartmain
    }
    if (this.cartView.cartdetails) {
      this.cartColl = this.cartView.cartdetails
    }
    this.cartView = this.cartservice.cartView;



  }

  fnVariationBtnClick(sizeid) {
    this.selectvariationid = sizeid;
    this.fnUpdateCartChange()
  }

  public fnAddBtnClick(dbo) {
    dbo.variationid = this.selectvariationid;
    var data = {
      action: 'ADD',
      abo: dbo
    }
    this.cartchangeData.emit(data)
  }

  public fnIncreseBtnClick(dbo) {
    dbo.variationid = this.selectvariationid;
    var data = {
      action: 'INCRESE',
      abo: dbo
    }
    this.cartchangeData.emit(data)
  }

  public fnDecreseBtnClick(dbo) {
    dbo.variationid = this.selectvariationid;
    var data = {
      action: 'DECRESE',
      abo: dbo
    }
    this.cartchangeData.emit(data)
  }

  public fnRemoveBtnClick(dbo) {
    dbo.variationid = this.selectvariationid;
    var data = {
      action: 'REMOVE',
      abo: dbo
    }
    this.cartchangeData.emit(data)
  }


  public cartClick() {

    this.emitData.emit("CART");
    this.activeModal.close(false);

  }



  public decline() {


    this.activeModal.close(false);
  }
  fnUpdateCartChange() {

    if (this.productBO.isvariation === 1) {
      
      const index = this.cartColl.findIndex(a => a.productid === this.productBO.productid &&  Number(a.variationid) === Number(this.selectvariationid));
     
      if (index > -1) {
        this.productBO.quantity = this.cartColl[index].quantity;
      } else {
        this.productBO.quantity = 0;
      }
    }
    else {


      const index = this.cartColl.findIndex(a => a.productid === this.productBO.productid);
      if (index > -1) {
        this.productBO.quantity = this.cartColl[index].quantity;
      } else {
        this.productBO.quantity = 0;
      }
    }


  }

}
